import { Text } from "@salestrak/ui";
import type { EntityData } from "#app/lib/entity-visuals";
import { EntityTag } from "./entity-tag";

export const PLATFORM_ADMIN_NAME = "SalesTrak Admin";

type UserEntity = Extract<EntityData, { kind: "user" }>;

/** "SalesTrak Admin on behalf of <member>" — the actor line for anything a
 *  superuser did while impersonating that member. Inline text only; the
 *  SalesTrak avatar belongs in the surface's avatar slot beside it. */
export function OnBehalfLabel({ user }: { user: UserEntity["user"] & { userId?: string | null } }) {
  return (
    <Text size="sm">
      <Text size="sm" weight="semibold">
        {PLATFORM_ADMIN_NAME}
      </Text>
      <Text size="sm" variant="muted">
        {" on behalf of "}
      </Text>
      <EntityTag
        entity={{ kind: "user", id: user?.userId ?? "unknown", user }}
        display="label"
        weight="semibold"
        as="text"
      />
    </Text>
  );
}
